module.exports = __webpack_public_path__ + "static/img/map_bg.ae78d2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/map_bg.png
// module id = 8nuQ
// module chunks = 44